import React from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import { listStateKey, useRememberedFilter } from './listState';

/*
 * Filtro a scelta multipla con molti valori: una tendina con le caselle di spunta,
 * con la stessa etichetta dei chip. Tutti selezionati = nessun filtro.
 *
 *   options:  [{ value, label }]
 *   selected: [value]
 *   onChange(nuoviSelezionati)
 */
export const MultiSelectFilter = ({ label, options, selected, onChange }) => {
	useRememberedFilter(listStateKey('filtro', label), selected, onChange);
	const tutti = selected.length === options.length;
	const toggle = (v) => onChange(selected.includes(v) ? selected.filter((s) => s !== v) : [...selected, v]);

	// Il nome del filtro non sta più accanto (regola SUI 03/10/2026): lo dice la tendina
	let riassunto = 'Tutti';
	if (selected.length === 0) riassunto = 'Nessuno';
	else if (selected.length === 1) riassunto = options.find((o) => o.value === selected[0])?.label;
	else if (!tutti) riassunto = `${selected.length} selezionati`;
	riassunto = `${label}: ${riassunto}`;

	return (
		<div className="sid-chips">
			<span className="sid-chips__label">{label}</span>
			<Dropdown autoClose="outside">
				<Dropdown.Toggle
					as="button"
					type="button"
					className={`sid-select sid-chips__select sid-multi-toggle${tutti ? '' : ' is-active'}`}
					aria-label={label}
				>
					{riassunto}
				</Dropdown.Toggle>
				<Dropdown.Menu className="sid-multi-menu">
					<div className="sid-multi-menu__item">
						<Form.Check
							type="checkbox"
							id={`multi-${label}-tutti`}
							label="Tutti"
							checked={tutti}
							onChange={() => onChange(tutti ? [] : options.map((o) => o.value))}
						/>
					</div>
					<Dropdown.Divider />
					{options.map((o) => (
						<div key={o.value} className="sid-multi-menu__item">
							<Form.Check
								type="checkbox"
								id={`multi-${label}-${o.value}`}
								label={o.label}
								checked={selected.includes(o.value)}
								onChange={() => toggle(o.value)}
							/>
						</div>
					))}
				</Dropdown.Menu>
			</Dropdown>
		</div>
	);
};

export default MultiSelectFilter;
